module.exports = __webpack_public_path__ + "images/d8ad4e2908ddbf79bf6a8b211f8f87f2.svg";